import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground border-border",
        // New unified design system badges
        primary: "border-transparent bg-indigo-500 text-white hover:bg-indigo-600",
        soft: "border-indigo-200 dark:border-indigo-800 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300",
        teal: "border-transparent bg-teal-500 text-white hover:bg-teal-600",
        rose: "border-transparent bg-rose-500 text-white hover:bg-rose-600",
        amber: "border-transparent bg-amber-500 text-white hover:bg-amber-600",
        glass: "border-white/20 dark:border-white/10 bg-white/20 dark:bg-warmGray-900/20 backdrop-blur-sm text-foreground",
        cosmic: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        aurora: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        supernova: "border-transparent bg-cosmic-supernova text-black hover:bg-cosmic-supernova/80",
        meteor: "border-transparent bg-cosmic-meteor text-white hover:bg-cosmic-meteor/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
